import type { OrderComment } from '@/infrastructure/FulfillmentAdminClient';

/**
 * A thread holds two kinds of note (SSD-7265): one about the order, and one about a single product
 * line, which carries that line's number. The pane shows the first kind; each line shows its own.
 */
export const isLineMemo = (comment: OrderComment): comment is OrderComment & { lineNo: number } =>
  typeof comment.lineNo === 'number';

/** The notes about the order as a whole, in the order the server listed them. */
export const orderComments = (comments: readonly OrderComment[]): OrderComment[] =>
  comments.filter((comment) => !isLineMemo(comment));

/** The notes about one line, in the order they were written, so the newest sits last. */
export const lineMemos = (comments: readonly OrderComment[], lineNo: number): OrderComment[] =>
  comments.filter((comment) => comment.lineNo === lineNo);
